type ReleaseInfo = {
	release: string;
	build: string;
	commit: string;
}

const releaseInfo: ReleaseInfo = {
	release: '__RELEASE__',
	build: '125',
	commit: 'fb3ab0a'
};

export { releaseInfo };
